/******************************************************************************
 *
 * WorkItemsCard
 *
 * Runtime execution of Work Items.
 *
 * Future
 *
 * - Execute Item
 * - Complete Item
 * - Upload Photo
 * - Upload Documents
 * - Add Remarks
 * - QR Scan
 * - GPS Capture
 * - Digital Signature
 *
 ******************************************************************************/

import React from "react";

export default function WorkItemsCard({

    workItems = [],

    selectedWorkItem,

    onSelectWorkItem,

    onExecute,

    onView,

    onRefresh

}) {

    function getStatusBadge(status) {

        switch (status) {

            case "COMPLETED":
                return "bg-success";

            case "IN_PROGRESS":
                return "bg-warning text-dark";

            case "OPEN":
                return "bg-primary";

            case "CANCELLED":
                return "bg-danger";

            default:
                return "bg-secondary";

        }

    }

    return (

        <div
            className="card border-0 shadow-sm mb-4"
            style={{
                borderRadius: "14px",
                overflow: "hidden"
            }}
        >

            {/* =======================================================
                HEADER
            ======================================================= */}

            <div
                className="px-4 py-3"
                style={{
                    background:
                        "linear-gradient(90deg,#f8fafc,#eef4ff)"
                }}
            >

                <div className="d-flex justify-content-between align-items-center">

                    <div>

                        <h5 className="mb-1 fw-bold">

                            <i className="bi bi-list-check text-primary me-2"></i>

                            Work Items

                        </h5>

                        <small className="text-muted">

                            Execute and monitor runtime work items

                        </small>

                    </div>

                    <div className="d-flex align-items-center">

                        <button

                            className="btn btn-outline-primary btn-sm me-2"

                            onClick={onRefresh}

                        >

                            <i className="bi bi-arrow-clockwise me-1"></i>

                            Refresh

                        </button>

                        <span className="badge rounded-pill bg-secondary">

                            {workItems.length} Items

                        </span>

                    </div>

                </div>

            </div>

            {/* =======================================================
                BODY
            ======================================================= */}

            <div className="card-body p-3">

                {

                    workItems.length === 0

                        ?

                        <div className="text-center py-5 text-muted">

                            <i className="bi bi-inbox fs-1 d-block mb-3"></i>

                            No Work Items Found.

                        </div>

                        :

                        <div className="d-flex flex-column gap-3">

                            {workItems.map((item) => {

                                const selected =
                                    selectedWorkItem?.id === item.id;

                                return (

                                    <div

                                        key={item.id}

                                        role="button"

                                        tabIndex={0}

                                        onClick={() =>

                                            onSelectWorkItem &&

                                            onSelectWorkItem(item)

                                        }

                                        className={`border rounded p-3 ${

                                            selected

                                                ? "border-primary"

                                                : "border-light"

                                        }`}

                                        style={{

                                            background:

                                                selected

                                                    ? "#eef5ff"

                                                    : "#fff",

                                            transition: "0.2s",

                                            cursor: "pointer"

                                        }}

                                    >

                                        <div className="d-flex justify-content-between align-items-start">
                                                                                    

                                            <div className="flex-grow-1">

                                                <div className="d-flex align-items-center flex-wrap gap-2">

                                                    <div className="fw-bold fs-6">

                                                        {item.title}

                                                    </div>

                                                    <span
                                                        className={`badge rounded-pill ${getStatusBadge(item.status)}`}
                                                    >

                                                        {item.status}

                                                    </span>

                                                </div>

                                                <div className="mt-2">

                                                    <small className="text-muted">

                                                        <i className="bi bi-hash me-1"></i>

                                                        {item.work_no || "-"}

                                                    </small>

                                                </div>

                                                <div className="mt-2">

                                                    <small className="text-muted">

                                                        <i className="bi bi-calendar-event me-1"></i>

                                                        Due: {item.target_completion_date || "-"}

                                                    </small>

                                                </div>

                                            </div>

                                            <div className="ms-3">

                                                <button

                                                    className="btn btn-success btn-sm"

                                                    onClick={(e) => {

                                                        e.stopPropagation();

                                                        onExecute &&

                                                            onExecute(item);

                                                    }}

                                                >

                                                    <i className="bi bi-play-fill me-1"></i>

                                                    Execute

                                                </button>

                                            </div>

                                        </div>

                                        <div className="mt-3">

                                            <div className="d-flex justify-content-between mb-1">

                                                <small className="text-muted">

                                                    Progress

                                                </small>

                                                <small className="fw-semibold">

                                                    {

                                                        item.completion_percentage ||

                                                        0

                                                    }%

                                                </small>

                                            </div>

                                            <div
                                                className="progress"
                                                style={{
                                                    height: "8px",
                                                    borderRadius: "20px"
                                                }}
                                            >

                                                <div

                                                    className="progress-bar bg-success"

                                                    role="progressbar"

                                                    style={{

                                                        width: `${

                                                            item.completion_percentage ||

                                                            0

                                                        }%`

                                                    }}

                                                />

                                            </div>

                                        </div>

                                    </div>

                                );

                            })}
                                                    </div>

                }

            </div>

        </div>

    );

}